import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Container from '@material-ui/core/Container';
import { useMediaQuery } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import logo from '../../assets/logo-text-color.png';
import { LineScalePulseOut } from 'react-pure-loaders';

import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';

import { useLocation, useHistory } from 'react-router-dom';
import { confirmSignup } from '../../services/user';

import { toast } from 'react-toastify'
import { confirmAskFunds } from '../../services/response';
import { useEffect } from 'react';

const useStyles = makeStyles((theme) => ({
  main: {
    flex: 1,
    paddingTop: theme.spacing(4),
    width: '100%',
    overflow: 'auto',/* 'overlay', */
  },
  mainMobile: {
    paddingTop: theme.spacing(0),
    overflow: 'auto',/* 'overlay', */
  },
  root: {
    padding: 0,
  },
  paper: {
    height: '90%',
    width: '35vw',
    margin: 'auto',
  },
  paperMobile: {
    height: '100%',
    width: '100%',
    margin: 'auto',
  },
  position: {
    position: "relative",
    fontFamily: theme.typography.fontFamily,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'unset'
    }
  },

  underline: {
    textDecoration: "underline"

  },
  flip: {
    transform: "rotateY(360deg)",
    transition: "transform 0.7s",
  },
  backFlip: {
    transform: "rotateY(-360deg)",
    transition: "transform 0.7s",
  },
  divRegister: {
    textAlign: "center",
    marginTop: theme.spacing(2),
    paddingBottom: theme.spacing(7)
  },
  divRegisterMobile: {
    textAlign: "center",
    margin: "0vh"
  },
  textPattern: {
    color: '#000000'
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },

}));

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function ConfirmaSaque() {

  let query = useQuery()
  const classes = useStyles();
  const matches = useMediaQuery('(max-width:600px)');
  const history = useHistory();

  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);

    const token = query.get('token');
    await confirmAskFunds(token)
      .then(async (res) => {
        setSubmitting(false);
        toast.success('Saque confirmado com sucesso.', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        history.push('/financial-info')
      }).catch(error => {
        setSubmitting(false);
        if (error.response?.data?.status !== 400) {
          toast.error('Algo inesperado ocorreu. Por favor, tente novamente em alguns minutos.', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .finally(() => {
        setSubmitting(false);
      });

  };

  useEffect(() => {
    const token = query.get('token');
    if (!token) {
      history.push('/financial-info')
    }
  }, [])

  return (
    <div className={`${classes.main} ${matches ? (`${classes.mainMobile}`) : ''} `}>
      <Container className={classes.root} >
        <Paper
          className={matches ? classes.paperMobile : classes.paper}
          elevation={matches ? 0 : 3}
        >
          <div className={classes.root}>
            <form className={classes.form} noValidate onSubmit={handleSubmit} >
              <Button
                type="submit"
                size='large'
                fullWidth
                variant="contained"
                color='primary'
                className={classes.submit}
              >
                {submitting ? (
                  <LineScalePulseOut
                    color={'#BA7100'}
                    loading={submitting}
                  />
                ) : (
                  "Confirmar saque"
                )}
              </Button>
            </form>
          </div>
        </Paper>
      </Container>
    </div>
  );
}